module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "df42f5abd977e-d1e335"
    }
  }, [_c('span', {
    attrs: {
      "id": "pagevii"
    }
  }, [_c('h2', {
    staticClass: "acknowledgements-head"
  }, [_vm._v("ACKNOWLEDGEMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "acknowledgements-text"
  }, [_vm._v("With each new book I find myself thanking the same people for their support and encouragement. My husband, Steve, daughter, Katie and son, Sam, are my closest friends and the best cheering squad anyone could have. I can’t imagine my life without the friendship and advice of my writing buddies: Margaret Maron, Bren Witchger, Diane Chamberlain, Kathy Trocheck (Mary Kay Andrews), Katy Munger and Alexandra Sokoloff. My friend Vicky Bijur is the best agent in the world. And I am forever grateful that Quail Ridge Books and Music is my home bookstore.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ad8eb97a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781780107158_epub_ack.vue
// module id = 75
// module chunks = 0